import mori from 'mori';
import slugify from '../util/slugify';

const viewTypes = mori.vector('Map', 'Graph');

export default function(headers, selected = []) {
  return mori.distinct(mori.map(
    (header) => {
      const characteristic = mori.get(header, 'characteristic');
      const headerGroup = mori.get(header, 'headerGroup');
      // nested distributions need a complex slug
      const identifier = headerGroup ?
        `${headerGroup}__${characteristic}` :
        `${characteristic}`;
      const slug = slugify(identifier.replace('%', 'percent'));
      return mori.hashMap(
        'label', identifier.replace('__', ', '),
        'characteristic', characteristic,
        'slug', slug,
        'selected', selected.indexOf(slug) > -1,
        'headerGroup', headerGroup,
        'exclude', mapExcludedViews(header)
      );
    },
    mori.rest(headers)));
}

// Map the views where this distribution should not be shown
function mapExcludedViews(header) {
  return mori.transduce(
    mori.comp(
      mori.filter(
        (view) => `${mori.get(header, view, false)}`.toLowerCase() === 'no'
      ),
      mori.map((view) => view.toLowerCase())
    ),
    mori.completing(mori.conj),
    mori.vector(),
    viewTypes
  );
}



// WEBPACK FOOTER //
// ../datacenter/app/js/services/distributionFilters.js